import getActiveElement from '@mui/utils/getActiveElement';

export default getActiveElement;
